// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"59eb6c5d","65":"90e0c624","95":"347c87eb","130":"36a02e96","252":"d1f047d6","332":"ea50769a","402":"04e1352b","425":"06622e8e","602":"de36973d","636":"7bd48630","642":"1d1e0637","692":"c5cfca8b","737":"02fc4dea","844":"1ce3b943"}[chunkId] + ".chunk.js";
};